import React, { useState, useEffect } from 'react';
import '../popupbox/popupbox.css';

function Popupbox({ isOpen, onClose, defaultModelName = '' }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    modelName: defaultModelName,
    category: 'models',
    message: ''
  });

  // Automatically update the model name field whenever the selected model changes
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      modelName: defaultModelName
    }));
  }, [defaultModelName]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const whatsappNumber = "914657688567"; // Replace with your country code + phone number

    const message = `*Model Enquiry*
*Model Name:* ${formData.modelName || 'Not specified'}
*Name:* ${formData.name}
*Email:* ${formData.email}
*Phone:* ${formData.phone || 'N/A'}
*Category:* ${formData.category}
*Message:* ${formData.message}`;

    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');

    if (onClose) onClose();
  };

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-container" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>&times;</button>
        <h3>Enquire Now</h3>

        <form onSubmit={handleSubmit} className="popup-form">
          {/* Auto-filled Model Name */}
          <div className="form-group">
            <label htmlFor="modelName">Selected Model</label>
            <input
              type="text"
              id="modelName"
              name="modelName"
              value={formData.modelName}
              readOnly
              style={{ backgroundColor: '#2a2a2a', cursor: 'not-allowed' }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="name">Your Name</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Your Email</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="Enter phone number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              placeholder="Write your query..."
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <button type="submit" className="submit-btn">Send on WhatsApp</button>
        </form>
      </div>
    </div>
  );
}

export default Popupbox;